// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderMsg_wrapper__guH9O","errorBody":"OrderMsg_errorBody__pf7Ve"};